import { render, staticRenderFns } from "./pointsMXList.vue?vue&type=template&id=61908cd5&scoped=true&"
import script from "./pointsMXList.vue?vue&type=script&lang=ts&"
export * from "./pointsMXList.vue?vue&type=script&lang=ts&"
import style0 from "./pointsMXList.vue?vue&type=style&index=0&id=61908cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61908cd5",
  null
  
)

export default component.exports